import AdditionalDocuments from './AdditionalDocuments.styled';

export default AdditionalDocuments;
